// extracted by mini-css-extract-plugin
export default {"discoverSectionStack":"DiscoverSectionPage_discoverSectionStack__EupUX"};